function Footer() {
    return (
        <div className='flex justify-end  items-end '>
            <div className="w-full">
                <h3 className="mb-4 text-4xl font-extrabold leading-none tracking-tight text-gray-900 md:text-5xl lg:text-6xl dark:text-white p-5">
                    Por eso te esperamos en lo de Eli y Lucas el 01/05 a las 12
                </h3>
            </div>
            <img src="caro.png" alt="caroooo" className="w-32 h-32 mt-4" />
        </div>
    );
}

export default Footer;
